import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';
import {TIMEOUT_STORE} from 'util/constants';

const
    transformEntitiesFn = credential => {
        if (typeof credential !== 'object') {
            throw new Error('transformEntitiesFn needs an object to transform');
        }

        return {
            id:     credential.id,
            alias:  credential.alias,
            vendor: {
                selected: vendorCodes.azure_csp,
                values:   {
                    service:      credential.service.id,
                    clientId:     credential.client_id,
                    clientSecret: credential.client_secret,
                    tenant:       credential.tenant,
                    subscription: credential.subscription.id
                }
            }
        };
    },
    mapFields = {
        subscription:  'subscription',
        client_id:     'clientId',
        client_secret: 'clientSecret',
        tenant:        'tenant'
    },
    mapParametersToSave = {
        subscription: 'subscription',
        clientId:     'client_id',
        clientSecret: 'client_secret',
        tenant:       'tenant',
        service:      'service'
    },
    transformEntitiesToSaveFn = credential => Object.keys(credential.vendor)
        .reduce((ret, key) => ({
            ...ret,
            [mapParametersToSave[key]]: credential.vendor[key]
        }), {
            alias: credential.alias
        });

const exports = storeModuleFactory({
    name:             'azureCredentials',
    endpoint:         endpoints.securityCredentials.azure.endpoint,
    instanceEndpoint: endpoints.securityCredentials.azure.instanceEndpoint,
    callbackActions:  [{
        method: 'create',
        action: invalidateSecurityCredentials
    },{
        method: 'update',
        action: invalidateSecurityCredentials
    },{
        method: 'delete',
        action: invalidateSecurityCredentials
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/azureCredentials.js